import React, { useEffect, useState } from "react";
import moment from "moment";
import { Tab, Tabs } from "react-bootstrap";
import store from "../../store/Store";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import {
	getAggregateWeeklyPlan,
	getAggregateDailyContainerPlanning,
} from "../../services/aggregateDataService";
import {
	CONTAINER_TYPE_WISE_WEEKLY_PLAN,
	COUNTRY_WISE_WEEKLY_PLAN,
} from "../columns/aggregateBookingColumns";
import { aggregateDataCreatorForStore } from "../../utils/dataFilter";
import CreateNewSchedule from "../common/CreateNewSchedule";
import MonthlyPlanViewer from "../common/MonthlyPlanViewer";
import BasicDataTable from "../common/BasicDataTable";
import Counters from "../common/Counters";
import AggregateTable from "../common/tables/AggregateTable";
import { exportData } from "../../utils/helpers";
import Loader from "../Loader";
import UploadAggregatePlan from "../common/upload-new-data/UploadAggregatePlan";
import AggregateActionCenter from "../common/action-center/AggregateActionCenter";
import { getReasonsForErrorInShipmentBooking } from "../../services/tractorDataService";
import { includes, filter } from "lodash";
import AggregateDailyPlan from "../../assets/ExcelData/AggregateDailyPlan.json";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import { PulseLoader } from "react-spinners";
import { uniqBy } from "lodash";
import { getTransporterList } from "../../services/dataService";	
import DailyDashboardPlanViewer from "../common/DailyDashboardPlanViewer";

function AggregateBooking() {
	const [loader, setLoader] = useState(false);
	const [data, setData] = useState([]);
	const [date, setDate] = useState(
		moment().add(1, "days").format("YYYY-MM-DD")
	);
	const [type, setType] = useState(localStorage.getItem("agg-tab-key"));
	const [reasons, setReasons] = useState();
	const [showCreateNewSchedule, setShowCreateNewSchedule] = useState(false);
	const [showDailyPlanUploader, setShowDailyPlanUploader] = useState(false);
	const [monthlyData, setMonthlyData] = useState({});
	const [selectedDate, setSelectedDate] = useState(moment());
	const [selectedMonth, setSelectedMonth] = useState(selectedDate);
	const [weeklyCountryWiseData, setWeeklyCountryWiseData] = useState([]);
	const [weeklyContainerTypeWiseData, setWeeklyContainerTypeWiseData] =
		useState([]);
	const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);
	// const [counter, setCounter] = useState({
	// 	Booked: 0,
	// 	Pending: 0,
	// 	Approved: 0,
	// 	Cancelled: 0,
	// 	Not_Booked: 0,
	// });
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [countData, setCountData] = useState({
		label : [],
		counterData : {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
		}
	})
	const [transporterList, setTransporterList] = useState("");

	// useEffect(() => {
	// 	setCounter(getCount(data));
	// }, [data]);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().daily_aggregate_bookings));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "Aggregate", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Aggregate", View: 1 })
			);
		}
	}, [userData]);

	useEffect(() => {
		let mounted = true;
		async function getDropdownOptions() {
			try {
				if (type === "Daily") {
					const reasonList = await getReasonsForErrorInShipmentBooking();
					if (mounted) {
						setReasons(reasonList.data);
					}
				}
			} catch (error) {}
		}
		if (!reasons) {
			getDropdownOptions();
		}
		return () => {
			mounted = false;
		};
	}, [reasons, type]);

	const resetStorage = () => {
		setData([]);
		setWeeklyContainerTypeWiseData([]);
		setWeeklyCountryWiseData([]);
		setMonthlyData({});
	};

	useEffect(() => {
		let mounted = true;
		let counterLabel = []
		let counterValue = {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
			Hold:0,
		}
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				if (type === "Daily") {
					const response = await getAggregateDailyContainerPlanning(
						moment(date).format("YYYY-MM-DD")
					);
					if (mounted) {
						dispatcher(
							actionTypes.AGGREGATE_BOOKING_LOADED,
							aggregateDataCreatorForStore(response.data.Resultset1)
						);
					}
					for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Hold"){
							counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
						}
					}
					setCountData({label : counterLabel, counterData : counterValue})
				}
				if (type === "Weekly") {
					const countryResp = await getAggregateWeeklyPlan(
						moment(date).format("MMM-YY"),
						"Country"
					);
					const marketResp = await getAggregateWeeklyPlan(
						moment(date).format("MMM-YY"),
						"ContainerType"
					);
					if (mounted) {
						setWeeklyCountryWiseData(countryResp.data);
						setWeeklyContainerTypeWiseData(marketResp.data);
					}
				}
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setCountData({
						label : [],
						counterData : {
							Booked: 0,
							Pending: 0,
							Approved: 0,
							Cancelled: 0,
							Not_Booked: 0,
							Hold:0,
						}
					})
				}
			}
		}
		getPlan();
		return () => (mounted = false);
	}, [date, type, selectedMonth, setCountData]);

	useEffect(() => {
	async function getTransporterData() {
		if (type === "Daily") {
			try {
			const response = await getTransporterList();
			const uniqContainerCountData = uniqBy(
				response.data,
				"TransporterName"
			);
			setTransporterList(uniqContainerCountData);
			} catch (error) {}
		}
	}
	getTransporterData();
	}, [type]);

	const dataExportHandler = () => {
		if (type === "Daily") {
			var finalExportData = [];
			for (let i = 0; i < data.length; i++) {
				for (let j = 0; j < data[i].subRows.length; j++) {
					if (
						!includes(finalExportData, {
							DailyContainerPlanningAggregateId:
								data[i].subRows[j].DailyContainerPlanningAggregateId,
						})
					) {
						finalExportData.push(data[i].subRows[j]);
					}
				}
			}
			exportData(
				finalExportData.map((item) => {
					return {
						OFP_PLAN_DATE: item["Date"],
						COUNTRY: item["Country"],
						TRANSPORTER: item["Transporter"],
						PORT_OF_DESTINATION: item["Port_Of_Destination"],
						PART_NUMBER: item["PartNumber"],
						CATEGORY: item["Category"],
						SUBCATEGORY: item["SubCategory"],
						QUANTITY: item["Quantity"],
						CONTAINER_COUNT: item["Container_Count"],
						CONTAINER_TYPE: item["Container_Type"],
						INSPECTION: item["Inspection"],
						REMARK: item["Remark"],
						BOOKING_NUMBER: item["Booking_Number"],
						BOOKING_DOC: item["BookingDocument"],
						REASON: item["Reason"],
						STATUS: item["STATUS"],
						VSL_VOY: item["VSL_VOY"],
						FINAL_DESTINATION: item["final_destination"],
						ETD: item["ETD"] === "Invalid date" ? "" : moment(item["ETD"]).format("DD-MM-YYYY"),
						ETA: item["ETA"] === "Invalid date" ? "" : moment(item["ETA"]).format("DD-MM-YYYY"),
						CARRIER: item["Carrier"],
						JD_STUFFING_DATE:
							item["JD_Stuffing_Date"] === "Invalid date"
								? ""
								: moment(item["JD_Stuffing_Date"]).format("DD-MM-YYYY"),
						GROUND_RENT_DAYS: item["Ground_Rent_Days"],
						ORIGIN_TRANSIT_TIME: item["Origin_Transit_Time"],
						APPROX_CONTAINER_DETENSION: item["Approx_container_detention"],
					};
				}),
				`Aggregate_daily_plan${moment(date).format("MMM-YYYY")}`
			);
		} else if (type === "Weekly") {
			exportData(
				weeklyCountryWiseData,
				`Aggregate_weekly_country_wise_plan${moment(date).format("MMM-YYYY")}`
			);
			exportData(
				weeklyContainerTypeWiseData,
				`Aggregate_weekly_ContainerType_wise_plan${moment(date).format(
					"MMM-YYYY"
				)}`
			);
		} else if (type === "Monthly") {
			exportData(
				monthlyData,
				`Aggregate_monthly_plan${moment(date).format("MMM-YYYY")}`
			);
		}
	};

	const aggregateTemplateFileExportHandler = () => {
		exportData(
			AggregateDailyPlan,
			`Aggregate Daily Plan Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>Aggregate</h1>
				{type === "Daily" && (
					<Counters
						counter={countData.counterData}
						label={countData.label}
						styleData="df_dailyCounter"
					/>
				)}
			</div>
			<CreateNewSchedule
				show={showCreateNewSchedule}
				handleClose={() => setShowCreateNewSchedule(false)}
			/>
			{showDailyPlanUploader && <UploadAggregatePlan
				show={showDailyPlanUploader}
				handleClose={() => setShowDailyPlanUploader(false)}
				setNoDataState={setNoDataState}
				setCountData={setCountData}
				date={date}
				setDate={setDate}
			/>}
			<Tabs
				activeKey={type}
				defaultActiveKey={"Daily"}
				style={{
					marginTop: "-20px",
				}}
				onSelect={(k) => {
					setType(k);
					localStorage.setItem("agg-tab-key", k);
				}}
			>
				<Tab eventKey="Daily" title="Daily plan">
					{loader && (
						<PulseLoader
							color="#007bff"
							size="20px"
							margin="10px"
							style={{ position: "relative", top: "40vh", left: "45%" }}
						/>
					)}
					{!loader && noDataState && (
						<img
							src={noDataAvailable}
							alt="notAvailableImg"
							className="noDataFoundImg"
							// style={{marginLeft:"-2%"}}
						/>
					)}
					{!loader && type === "Daily" && (
						<AggregateTable
							tableData={data}
							reasons={reasons}
							date={date}
							setDate={setDate}
							setShowCreateNewSchedule={setShowCreateNewSchedule}
							setShowDailyPlanUploader={setShowDailyPlanUploader}
							dataExportHandler={dataExportHandler}
							aggregateTemplateFileExportHandler={
								aggregateTemplateFileExportHandler
							}
							subModule="Daily"
							type={"Daily"}
							newSelectedFlatRows={newSelectedFlatRows}
							setNewSelectedFlatRows={setNewSelectedFlatRows}
							filteredUserAccessData={filteredUserAccessData}
							noDataState={noDataState}
							setNoDataState={setNoDataState}
							countData={countData}
							setCountData={setCountData}
							transporterList={transporterList}
						/>
					)}
				</Tab>
				<Tab eventKey="Weekly" title="Weekly plan">
					{loader && <Loader />}
					{!loader && type === "Weekly" && (
						<>
							<div className="table_actions">
								{/* <Form.Group>
                  <Form.Control
                    className="hiden-inp"
                    placeholder="search here.."
                  />
                </Form.Group> */}
								<AggregateActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									subModule="Weekly"
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
								/>
							</div>
							<BasicDataTable
								columns={COUNTRY_WISE_WEEKLY_PLAN}
								data={weeklyCountryWiseData}
								customPageSize={4}
							/>
							<BasicDataTable
								columns={CONTAINER_TYPE_WISE_WEEKLY_PLAN}
								data={weeklyContainerTypeWiseData}
								customPageSize={4}
							/>
						</>
					)}
				</Tab>
				<Tab eventKey="Monthly" title="Monthly plan">
				
					{loader && <Loader />}
					{!loader && type === "Monthly" && (
						<>
							<div className="table_actions">
								{/* <Form.Group>
                  <Form.Control
                    className="hiden-inp"
                    placeholder="search here.."
                  />
                </Form.Group> */}
								<AggregateActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									type={"month"}
									subModule="Monthly"
									selectedMonth={selectedMonth}
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
									monthlyData={monthlyData}
								/>
							</div>
							<MonthlyPlanViewer
								setSelectedDate={setSelectedDate}
								monthlyData={monthlyData}
								selectedDate={selectedDate}
								selectedMonth={selectedMonth}
								setSelectedMonth={setSelectedMonth}
								firstKey={"Country"}
								secondKey={"ContainerType"}
								dataType="Aggregate"
							/>
						</>
					)}
				</Tab>

				<Tab eventKey="Daily Dashboard" title="Daily Dashboard">
  {loader ? (
    <PulseLoader
      color="#007bff"
      size="20px"
      margin="10px"
      style={{ position: "relative", top: "40vh", left: "45%" }}
    />
  ) : (
    <>
    

      <DailyDashboardPlanViewer
        monthlyData={monthlyData}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        firstKey={"Market"}
        secondKey={"Country"}
        dataType="Aggregate"
		type={"DailyDashboard"}
        subModule="Daily Dashboard"
        setMonthlyData={setMonthlyData}
        
      />
    </>
  )}
</Tab>
			</Tabs>
		</>
	);
}

export default AggregateBooking;
